<script>
    export let selectedService = {};
</script>

<div class="navarea__wrapper">
    <a href="https://nara-sightseeing.com/" class="header-logo">
        <!-- <img src="https://nara-sightseeing.com/ns/wp-content/themes/inbound-nara-201902/images/common/logo_ordermaid_168-145.png" alt="KANSAI NARA TREASURE TRAVEL"> -->
        <img
            src="https://nara-sightseeing.com/ns/wp-content/themes/inbound-nara-201902/images/common/logo_new.png"
            alt="KANSAI NARA TREASURE TRAVEL"
        />
    </a>
    <div class="sp header-btn"><span /></div>
    <div class="gnav__wrapper">
        <nav class="gnav">
            <ul class="gnav__list">
                <li class="gnav__item">
                    <a href="https://nara-sightseeing.com/about/">About NARA</a>
                </li>
                <!-- <li class="gnav__item"><a href="https://nara-sightseeing.com/itinerary">Our Sample Itinerary</a></li>
                    <li class="gnav__item"><a href="https://nara-sightseeing.com/short-trip">Short TRIP</a></li> -->
                <li class="gnav__item">
                    <a href="https://nara-sightseeing.com/itinerary"
                        >Sample Itineraries & Tours</a
                    >
                </li>
                <li class="gnav__item contact">
                    <a href="https://nara-sightseeing.com/requestform"
                        >CONTACT</a
                    >
                </li>
            </ul>
        </nav>
        <div class="header-contact" />
        <div class="header-search sp" />
    </div>
</div>

<div class="header-imgarea">
    <div class="header-slider">
        <div
            class="header-slider__item slide-01"
            style="background-image: url({selectedService?.Thumbnail ||
                'https://nara-sightseeing.com/ns/wp-content/uploads/2019/05/MV3_0524.jpg'}); opacity: 0.85;"
        />
    </div>
    <div class="header-copy__container">
        <h1 class="header-copy">
            <span class="main"
                >{selectedService?.Name || 'Sample Itineraries & Tours'}</span
            ><span class="sub" />
        </h1>
    </div>
</div>
